<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>mScope Competitive Mappings</strong>
        </div>
        <b-row>
          <b-col md="5" class="my-0">
            <b-row>
              <div class="col-lg-6 p-0">
                <dx-select-box id="selVehicleSet" style="width: 100%;" :items="competitiveSets" value-expr="id"
                               display-expr="title" :value.sync="activeCompetitiveSetId"
                               name="Vehicle Set">
                </dx-select-box>
              </div>
              <div class="col-lg-6 p-0">
                <button id="btnSaveSetAs" class="btn btn-success pull-right ml-1" v-b-modal.modal-prevent-closing>
                  <i class="fa fa-save"></i> <strong class="text-white">Save Set As</strong>
                </button>
                <button id="btnSaveSet" class="btn btn-success pull-right" @click="saveCompetitiveSet" v-if="activeCompetitiveSetId !== -1">
                  <i class="fa fa-save"></i> <strong class="text-white">Save Set</strong>
                </button>
              </div>
            </b-row>
            <b-row>
              <div style="height: 78vh; overflow: auto">
                <DxDataGrid id="gridContainer"
                            :ref="dataGridRefName"
                            :data-source="availableNewVehicles"
                            :show-borders="true"
                            :selection="{ mode: 'single' }"
                            :columns="columns"
                            key-expr="ID"
                            @selection-changed="onSelectionChanged"
                            no-data-text="Loading Vehicles">
                  <DxFilterRow :visible="true" />
                  <DxHeaderFilter :visible="true" />
                  <DxPaging :page-size="20" />
                </DxDataGrid>
              </div>
            </b-row>
          </b-col>
          <b-col class="col-lg-12 col-xl-7" v-if="initLoad">
            <div class="col-lg-7 offset-lg-2" style="text-align: center; height: 100%; opacity: 0.7; filter: alpha(opacity=70);">
              <div style="text-align: right; margin-top: calc(50vh - 250px);">
                <img src="/web/img/mscope_logo.png" alt="mGuage Logo" class="img-fluid">
                <h4 style="margin-right: 2rem !important;">State of the Art Analysis for OEMs.</h4>
              </div>
            </div>
          </b-col>
          <b-col md="7" v-else>
            <div v-if="activeCompetitiveSet">
              <form class="validationForm" onsubmit="event.preventDefault(); return false;">
                <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                  <tbody>
                    <tr v-if="1 === 2" class="b-table-empty-row">
                      <td><div role="alert" aria-live="polite"><div class="text-center my-2">No vehicles added created yet.</div></div></td>
                    </tr>
                    <tr>
                      <b-row class="mt-4">
                        <b-col lg="2">
                          <b-card>
                            <div slot="header">
                              <strong>Year</strong>
                            </div>
                            <div style="height: 62vh; overflow: auto">
                              <b-form-checkbox-group stacked :plain="true"
                                                     v-model="activeCompetitiveSet.years"
                                                     :checked="activeCompetitiveSet.years"
                                                     v-validate="{required: true}"
                                                     name="Year"
                                                     v-bind:class="{'is-invalid': validateErrors.has('Year') }">
                                <b-form-checkbox :id="y.toString()" v-for="y in sortArrays(formOptions.years)" :value="y"
                                                 v-bind:key="y" :disabled="activeCompetitiveSetId === -1">
                                  {{ y.toString() }}
                                </b-form-checkbox>
                              </b-form-checkbox-group>
                            </div>
                          </b-card>
                        </b-col>
                        <b-col lg="4">
                          <b-card>
                            <div slot="header">
                              <strong>Make/Model</strong>
                            </div>
                            <div style="height: 62vh; overflow: auto">
                              <div v-for="make in sortArrays(formOptions.makes)">
                                <strong>{{make.Name}}</strong><br />
                                <b-form-checkbox-group stacked :plain="true"
                                                       v-model="activeCompetitiveSet.models"
                                                       :checked="activeCompetitiveSet.models"
                                                       v-validate="{required: true}"
                                                       name="Model"
                                                       v-bind:class="{'is-invalid': validateErrors.has('Model') }">
                                  <b-form-checkbox :id="m.Name" v-for="m in sortArrays(formOptions.models)" v-if="m.MakeID === make.MakeID" :value="m"
                                  <b-form-checkbox :id="m.ModelID.toString()" v-for="m in sortArrays(formOptions.models)" v-if="m.MakeID === make.MakeID" :value="m"
                                                   v-bind:key="m.ModelID" :disabled="activeCompetitiveSetId === -1">
                                    {{ m.Name }}
                                  </b-form-checkbox>
                                </b-form-checkbox-group>
                              </div>
                            </div>
                          </b-card>
                        </b-col>
                        <b-col lg="6">
                          <b-card>
                            <div slot="header">
                              <strong>Trim</strong>
                            </div>
                            <div style="height: 62vh; overflow: auto">
                              <div v-for="make in sortArrays(formOptions.makes)" v-bind:key="make.MakeID">
                                <div v-if="model.MakeID === make.MakeID" v-for="model in sortArrays(activeCompetitiveSet.models)" v-bind:key="model.ModelID">
                                  <strong>{{make.Name}} - {{model.Name}}</strong><br />
                                  <b-form-checkbox-group stacked :plain="true"
                                                         v-model="activeCompetitiveSet.trims"
                                                         :checked="activeCompetitiveSet.trims"
                                                         v-validate="{required: true}"
                                                         name="Trim">
                                    <b-form-checkbox :id="t.ID.toString()" v-if="t.Model.ModelID === model.ModelID" v-for="t in formOptions.trims" :value="t"
                                                     v-bind:key="t.ID" :disabled="activeCompetitiveSetId === -1">
                                      {{ t.ShortDescription }}
                                    </b-form-checkbox>
                                  </b-form-checkbox-group>
                                </div>
                              </div>
                            </div>
                          </b-card>
                        </b-col>
                      </b-row>
                    </tr>
                  </tbody>
                </table>
              </form>
            </div>
            <div v-else>
              <table class="table b-table table-striped table-hover table-bordered table-sm">
                <tbody class="">
                  <tr class="b-table-empty-row"><td><div role="alert" aria-live="polite"><div class="text-center my-2">Select a vehicle set to edit.</div></div></td></tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>

      </b-card>
    </div>

    <b-modal id="modal-prevent-closing"
             ref="modal"
             title="Save Set As"
             @show="resetModal"
             @ok="handleOk">

      <form ref="form" class="validationForm" data-vv-scope="NewTitle" @submit.stop.prevent="handleSubmit">
        <label>Name</label><br />
        <b-form-input id="report-input"
                      v-model="new_title"
                      v-validate="{required: true}" :maxlength="250"
                      v-bind:class="{'is-invalid': validateErrors.has('NewTitle.Name') }" name="Name"
                      required></b-form-input>
        <em class="error invalid-feedback">{{ validateErrors.first('NewTitle.Name') }}</em>
      </form>
    </b-modal>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import notify from 'devextreme/ui/notify'
import {Validator} from 'vee-validate'
import {
  DxTextBox,
  DxSlider,
  DxNumberBox,
  DxLookup,
  DxSelectBox,
  DxSwitch,
  DxDropDownBox,
  DxDateBox,
  DxButton,
  DxList
} from 'devextreme-vue'
import DxPopup, {DxToolbarItem} from 'devextreme-vue/popup'
import { confirm, alert} from 'devextreme/ui/dialog'
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxSearchPanel,
  DxFilterRow,
  DxPager,
  DxPaging
} from 'devextreme-vue/data-grid'

export default {
  components: {
    loading,
    DxTextBox,
    DxSlider,
    DxNumberBox,
    DxLookup,
    DxSelectBox,
    DxSwitch,
    DxDropDownBox,
    DxPopup,
    DxToolbarItem,
    DxDateBox,
    DxButton,
    DxList,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxSearchPanel,
    DxFilterRow,
    DxPager,
    DxPaging
  },
  props: ['vehicleSetId', 'filteredModels'],
  created () {
    const filteredModels = this.$props.filteredModels
    axios.get('/api/mscope/getvehicles')
      .then(response => {
        const responseVehicles = response.data['NewVehicles']
        const vehicles = []
        responseVehicles.forEach(function (v) {
          if (filteredModels !== undefined && filteredModels !== null && filteredModels.length > 0) {
            if (!filteredModels.includes(v.Model.ModelID)) { return }
          }
          delete v.CategoryName
          delete v.ClassName
          v.Make.Name = v.Make.Name.replace('_', ' ')
          v.Model.Name = v.Model.Name.replace('_', ' ')
          vehicles.push(v)
        })
        this.availableNewVehicles = vehicles
        this.formOptions.years = _.uniq(_.map(this.availableNewVehicles, 'Year'))
        this.formOptions.makes = _.uniqBy(_.map(this.availableNewVehicles, 'Make'), 'MakeID').sort()
        this.formOptions.models = _.uniqBy(_.map(this.availableNewVehicles, 'Model'), 'ModelID').sort()
      })
      .catch(error => {
        if (error.response.status === 403) { this.$router.push('/login') }
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      })
    this.loadCompetitiveSets()
    this.initLoad = true
  },
  data () {
    return {
      errMsg: '',
      initLoad: true,
      changesSaved: true,
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      activeVehicle: -1,
      activeCompetitiveSetId: -1,
      competitiveMappingSet: { id: -1, title: '', mappingSet: [] },
      blankCompetitiveMappingSet: { id: -1, title: '', mappingSet: [] },
      blankMappingSet: { competitiveVehicleId: -1, years: [], makes: [], models: [], trims: [] },
      availableNewVehicles: [],
      competitiveSets: [],
      formOptions: {},
      new_title: '',
      dataGridRefName: 'dataGrid',
      columns: [
        {
          dataField: 'ID',
          visible: false
        }, {
          caption: '',
          dataField: 'Year',
          alignment: 'center',
          width: 60
        }, {
          caption: 'Make',
          dataField: 'Make.Name',
          width: 100
        }, {
          caption: 'Model',
          dataField: 'Model.Name',
          width: 120
        }, {
          caption: 'MSCode',
          dataField: 'MsCode',
          width: 120
        }, {
          caption: 'Trim',
          dataField: 'ShortDescription'
        }
      ]

    }
  },
  methods: {
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      if (this.new_title.length > 0) {
        this.handleSubmit()
      }
    },
    onlyUnique (value, index, self) {
      return self.indexOf(value) === index
    },
    sortArrays (arrays) {
      return _.orderBy(arrays, 'Name', 'asc')
    },
    handleSubmit() {
      var self = this
      if (!this.$refs.form.checkValidity()) {
        return
      }
      const found = self.competitiveSets.find(element => element.title === self.new_title)
      if (found) {
        this.validateErrors.add({ 'field': 'Name', 'scope': 'NewTitle', 'msg': 'Name is not unique' })
        return
      }

      if (self.activeCompetitiveSetId === -1) {
        let competitiveMappingSet = JSON.parse(JSON.stringify(self.blankCompetitiveMappingSet))

        self.availableNewVehicles.filter(y => y.Year === Math.max.apply(null, self.formOptions.years)).forEach(function (v) {
          let mappingSet = JSON.parse(JSON.stringify(self.blankMappingSet))
          mappingSet.competitiveVehicleId = v.ID
          mappingSet.trims = _.map(self.availableNewVehicles.filter(x => x.Make.MakeID !== v.Make.MakeID && x.CategoryID === v.CategoryID && x.SubcategoryID === v.SubcategoryID && x.Year === v.Year), 'ID')
          competitiveMappingSet.mappingSet.push(mappingSet)
        })

        self.competitiveMappingSet = competitiveMappingSet
      }

      self.competitiveMappingSet.id = -1
      self.competitiveMappingSet.title = self.new_title.trim()
      self.new_title = ''
      self.saveCompetitiveSet()

      this.$nextTick(() => {
        this.$refs.modal.hide()
      })
    },
    resetModal() {
      this.new_title = 'Copy - ' + this.competitiveMappingSet.title
    },
    onSelectionChanged ({ selectedRowsData }) {
      var self = this
      self.initLoad = false

      const data = selectedRowsData[0]
      // console.log(data)
      self.selectVehicle(data.ID)
    },
    unique (value, index, self) {
      return self.indexOf(value) === index
    },
    orderDesc (a, b) {
      return a < b
    },
    loadCompetitiveSets () {
      axios.get('/api/mscope/loadcompetitivesets')
        .then(response => {
          let competitiveSets = []
          var defaultSet = { id: -1, title: 'Default Market Scan Set' }
          competitiveSets.push(defaultSet)
          competitiveSets = competitiveSets.concat(JSON.parse(JSON.stringify(response.data.data)))
          this.competitiveSets = competitiveSets
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    loadDefaultCompetitiveSet() {
      var self = this

      let competitiveMappingSet = JSON.parse(JSON.stringify(self.blankCompetitiveMappingSet))
      let mappingSet = JSON.parse(JSON.stringify(self.blankMappingSet))

      var v = this.availableNewVehicles.find(x => x.ID === self.activeVehicle)
      mappingSet.competitiveVehicleId = self.activeVehicle
      mappingSet.years.push(v.Year)
      mappingSet.trims = self.availableNewVehicles.filter(x => x.Make.MakeID !== v.Make.MakeID && x.CategoryID === v.CategoryID && x.SubcategoryID === v.SubcategoryID && x.Year === v.Year)
      mappingSet.makes = _.uniqBy(_.map(mappingSet.trims, 'Make'), 'MakeID').sort()
      mappingSet.models = _.uniqBy(_.map(mappingSet.trims, 'Model'), 'ModelID').sort()

      competitiveMappingSet.mappingSet.push(mappingSet)
      self.competitiveMappingSet = competitiveMappingSet
    },
    loadCompetitiveSet(id) {
      var self = this
      self.activeCompetitiveSetId = id
      if (self.activeCompetitiveSetId === -1) {
        return
      }

      var obj = { id: self.activeCompetitiveSetId }

      axios.post('/api/mscope/loadcompetitiveset', obj)
        .then(response => {
          self.changesSaved = false
          var data = JSON.parse(JSON.stringify(response.data))

          setTimeout(() => {
            let competitiveMappingSet = JSON.parse(JSON.stringify(self.blankCompetitiveMappingSet))
            competitiveMappingSet.id = data.id
            competitiveMappingSet.title = data.title

            data.mappingSet.forEach(function (ms) {
              let mappingSet = JSON.parse(JSON.stringify(self.blankMappingSet))
              mappingSet.competitiveVehicleId = ms.competitiveVehicleId
              ms.mappingSet.forEach(function (v) {
                mappingSet.trims = mappingSet.trims.concat(self.availableNewVehicles.filter(x => x.ID === v))
              })
              mappingSet.makes = _.uniqBy(_.map(mappingSet.trims, 'Make'), 'MakeID').sort()
              mappingSet.models = _.uniqBy(_.map(mappingSet.trims, 'Model'), 'ModelID').sort()
              mappingSet.years = _.uniq(_.map(mappingSet.trims, 'Year'))

              competitiveMappingSet.mappingSet.push(mappingSet)
            })

            self.competitiveMappingSet = competitiveMappingSet
          }, 200)
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }
          self.errMsg = 'There was an error getting data : ' + error
          self.showDismissibleAlert = true
        })

    },
    selectVehicle (vehId) {
        var self = this
        self.initLoad = false

        self.activeVehicle = vehId
        if (self.activeCompetitiveSetId === -1) {
          self.loadDefaultCompetitiveSet()
          return
        }
    },
    saveCompetitiveSet () {
      var self = this

      const found = self.competitiveSets.find(element => element.title === self.activeCompetitiveSet.title && Number(element.id) !== self.activeCompetitiveSet.id)
      if (found) {
        self.validateErrors.add({ 'field': 'Name', 'scope': null, 'msg': 'Name is not unique' })
        return
      }

      let competitiveMappingSet = JSON.parse(JSON.stringify(self.blankCompetitiveMappingSet))
      competitiveMappingSet.id = self.competitiveMappingSet.id
      competitiveMappingSet.title = self.competitiveMappingSet.title

      let mappingSet = []
      self.competitiveMappingSet.mappingSet.forEach(function (ms) {
        var obj = {
          competitiveVehicleId: ms.competitiveVehicleId,
          mappingSet: []
        }
        if (self.activeVehicle === -1) {
          obj.mappingSet = ms.trims
        } else {
          obj.mappingSet = _.map(ms.trims, 'ID')
        }
        mappingSet.push(obj)
      })
      competitiveMappingSet.mappingSet = mappingSet

      self.$validator.validateAll().then((result) => {
        if (result) {
          axios.post('/api/mscope/savecompetitiveset', competitiveMappingSet)
            .then(response => {
              self.changesSaved = true
              self.competitiveMappingSet.id = response.data.id
              self.loadCompetitiveSets()
              notify('Competitive Set has been saved', 'success', 3500)
            })
            .catch(error => {
              if (error.response.status === 403) { this.$router.push('/login') }
              console.log(error.response)
              this.errMsg = 'There was an error saving: ' + error.response.statusText
              this.showDismissibleAlert = true
              notify('Error saving vehicle set', 'error', 3500)
            })
        }
      })
    }
    },
  computed: {
    activeCompetitiveSet() {
      const self = this
      let blank = { competitiveVehicleId: -1, years: [], makes: [], models: [], trims: [] }
      let mappingSet = self.competitiveMappingSet.mappingSet.find(vs => vs.competitiveVehicleId === self.activeVehicle)
      if (mappingSet === undefined || mappingSet === null) {
        return blank
      }
      return mappingSet
    }
  },
  watch: {
    'activeCompetitiveSet.models': function (val, oldVal) {
      if (val === undefined || val === null || val === -1 || oldVal === val) { return }

      const trims = []
      let index1 = this.availableNewVehicles.length
      for (let x = 0; x < index1; x++) {
        let v = this.availableNewVehicles[x]

        let index3 = this.activeCompetitiveSet.models.length
        for (let z = 0; z < index3; z++) {
          let m = this.activeCompetitiveSet.models[z]
          if (m.ModelID === v.Model.ModelID) { trims.push(v) }
        }
      }
      this.formOptions.trims = trims
    },
    activeCompetitiveSetId: function (val, oldVal) {
      if (val === undefined || val === null || val === -1 || oldVal === val) { return }

      let self = this
      self.loadCompetitiveSet(val)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.changesSaved) {
      let result = confirm('You have unsaved changes. Would you like to proceed and discard?', 'Warning')
      result.then((dialogResult) => {
        if (!dialogResult) {
          return next(false)
        } else {
          return next()
        }
      })
    } else {
      return next()
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = false
  }
}
</script>

<style>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/mScopeCompetitiveMappings.vue